// DO NOT MODIFY - this file is auto-generated by build-icons.js
// @ts-nocheck
import React from 'react';
import Icon from '../shared/icon';

/* eslint-disable react/jsx-max-props-per-line,react/jsx-space-before-closing,react/jsx-tag-spacing */

const BackIcon = (props) => (
  <Icon {...props}>
    {
      ({ color, width, height }) => (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
          <path d="M59.187 7.41L24.192 42.405a10.39 10.39 0 0 0-3.05 7.418 10.388 10.388 0 0 0 3.05 7.417l34.995 34.996c4.07 4.068 10.665 4.068 14.734 0 4.07-4.07 4.07-10.666 0-14.734l-27.677-27.68 27.68-27.678c4.068-4.07 4.068-10.665 0-14.734-4.07-4.07-10.666-4.07-14.735 0"/>
        </svg>
      )
    }
  </Icon>
);

export default BackIcon;
